export function addI18nNamespaceToErrorMessage(namespace: string) {
  return (data: any) => {
    if (data._embedded && data._embedded.errors) {
      data._embedded.errors.forEach((error: any) => {
        const firstErrorChar = error.message[0];
        const lastErrorChar = error.message[error.message.length - 1];

        if (firstErrorChar === '{' && lastErrorChar === '}') {
          const dotsRegex = /\./g;

          error.message = error.message.slice(1, -1).replace(dotsRegex, '_');
        }

        error.message = `${namespace}:${error.message}`;
      });
    }

    return data;
  };
}
